import React from 'react';
import { relativeTime } from '../kit';
import { longDateTime } from './userModel';
import SectionHead from './SectionHead';

function When({ at, by }) {
  if (!at) return <span className="ak-muted">—</span>;
  return (
    <span>
      {longDateTime(at)} <span className="ak-muted">({relativeTime(at)}){by ? ` · by ${by}` : ''}</span>
    </span>
  );
}

/**
 * Activity section (edit only). Only fields actually stored on the user doc
 * (stamped by the API since the Users redesign); older accounts show "—".
 */
export default function ActivitySection({ user }) {
  const u = user || {};
  const rows = [
    { key: 'signin', label: 'Last sign-in', at: u.lastSignInAt, always: true },
    { key: 'invited', label: 'Invited', at: u.invitedAt, by: u.invitedBy, always: true },
    { key: 'reinvited', label: 'Invite re-sent', at: u.lastInvitedAt, by: u.lastInvitedBy },
    { key: 'created', label: 'Created', at: u.createdAt, by: u.createdBy, always: true },
    { key: 'updated', label: 'Last updated', at: u.updatedAt, by: u.updatedBy, always: true },
    { key: 'deactivated', label: 'Deactivated', at: u.deactivatedAt, by: u.deactivatedBy },
    { key: 'restored', label: 'Restored', at: u.restoredAt, by: u.restoredBy },
    { key: 'mfa', label: 'MFA reset', at: u.mfaResetAt, by: u.mfaResetBy },
  ].filter((r) => r.always || r.at);

  return (
    <section className="us-section" aria-labelledby="us-sec-activity">
      <SectionHead id="us-sec-activity" title="Activity" />
      <div className="us-card">
        <dl className="us-kv">
          {rows.map((r) => (
            <div className="us-kv-row" key={r.key}>
              <dt>{r.label}</dt>
              <dd><When at={r.at} by={r.by} /></dd>
            </div>
          ))}
        </dl>
        <span className="ak-help">Sign-ins are recorded when the app loads, at most every 10 minutes. Dates from before this tracking existed show —.</span>
      </div>
    </section>
  );
}
